import React, { useMemo } from 'react';
import FormSelectStatic from 'modules/transactions/components/FormSelectStatic';
import {
  ReportsProvider,
  useReportsContext,
} from 'partial/wrappers/ReportsContext';
import Button from 'partial/components/Button';
import { downloadArrayToCsv } from 'helper';
import dayjs from 'dayjs';
import FormDatePicker from 'partial/components/form/FormDatePicker';
import ListPanel from 'partial/components/ListPanel';
import { DownloadSimple } from '@phosphor-icons/react';

const options = [
  { label: 'Clients Information', value: 'client-information' },
  { label: 'Mask Name', value: 'mask-name' },
  { label: 'SMS Usage and SMS Consumption', value: 'sms-usage' },
  { label: 'SMS Requests', value: 'payment-transactions' },
  { label: `Current Balance`, value: 'current-balance' },
  { label: 'Registration Report', value: 'registration-report' },
];

function ReportsContainer() {
  const {
    payload,
    setFilter,
    current,
    setCurrent,
    currentConfig,
    exportData,
    isExporting,
  } = useReportsContext();
  const {
    title,
    exportFileName,
    component: Component,
    withFilter,
  } = currentConfig;

  const fileDate = useMemo(
    () =>
      payload?.date_from && payload?.date_to
        ? `${dayjs(payload?.date_from).format('YYYY-MM-DD')}-${dayjs(
            payload?.date_to,
          ).format('YYYY-MM-DD')}`
        : dayjs().format('YYYY-MM-DD'),
    [payload],
  );

  const fileName = `${exportFileName}_${fileDate}`;

  const handleExport = () => {
    downloadArrayToCsv(exportData, fileName);
  };

  return (
    <ListPanel
      filters={
        <>
          <FormSelectStatic
            name="type"
            data={options}
            value={current?.type}
            onChange={setCurrent}
            withClear={false}
          />
          {withFilter && (
            <FormDatePicker
              key={title}
              onChange={setFilter}
              defaultValue={dayjs().format('YYYY-MM-DD')}
            />
          )}
          <Button
            primary
            icon={DownloadSimple}
            className="ml-auto"
            onClick={handleExport}
            isLoading={isExporting}
            loadingLabel="Exporting…"
          >
            Export CSV
          </Button>
        </>
      }
    >
      {/*
        The solid primary-blue caption bar was a one-off used nowhere else.
        It is now the standard panel sub-header: tone and a hairline, no fill.
      */}
      <div className="px-4 py-2 bg-neutral-50 border-b border-neutral-200 text-xs font-semibold uppercase tracking-[.05em] text-neutral-500">
        {title}
      </div>
      <div className="flex-1 flex flex-col">
        <Component />
      </div>
    </ListPanel>
  );
}

function Reports() {
  return (
    <ReportsProvider>
      <ReportsContainer />
    </ReportsProvider>
  );
}

export default Reports;
